import type { CityConfig } from "../city-template/types";

export const quincyIlConfig: CityConfig = {
  city: "Quincy",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "quincy-il",
  route: "/cities/quincy-il",
  title: "Emergency Passport Quincy, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Quincy, Illinois — as fast as 24 hours. Fast passport renewal for Quincy University students and all Adams County residents. A+ BBB rated registered State Dept. courier serving westernmost Illinois and the Tri-State area.",
  h1: "Emergency & Expedited Passport Services in Quincy, IL",
  heroSubtitle: "Quincy University student with a study abroad acceptance to Italy and your passport's expired? Business traveler crossing the Mississippi for an international flight tomorrow? Historic river city family heading to Germany and no valid passports in the house? We help Quincy residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving Adams County and the Tri-State region.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Quincy%20Illinois%20historic%20downtown%20on%20the%20Mississippi%20River%20bluffs%20with%20elegant%20Victorian%20architecture%20and%20tree%20lined%20Maine%20Street%2C%20the%20Bayview%20Bridge%20spanning%20the%20Mississippi%20River%20at%20sunset%2C%20Quincy%20University%20campus%20with%20Francis%20Hall%20and%20brick%20buildings%2C%20Washington%20Park%20with%20historic%20bandstand%20and%20manicured%20gardens%2C%20the%20John%20Wood%20Mansion%20and%20historic%20district%2C%20classic%20Midwest%20river%20city%20with%20steep%20bluffs%20and%20river%20vistas%2C%20golden%20hour%20warm%20light%20over%20the%20Mississippi%20River%20valley&width=1800&height=700&seq=quincy-il-hero-001&orientation=landscape",
  heroImageAlt: "Quincy Illinois downtown and Mississippi River bluffs at golden hour",
  geoPosition: "39.9356;-91.4099",
  geoPlacename: "Quincy, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 4 hours 30 minutes northeast of Quincy via I-72 / I-55",
  },
  nearbyCitiesZips: [
    { name: "Quincy", zips: "62301, 62305" },
    { name: "Hannibal, MO", zips: "63401" },
    { name: "Palmyra, MO", zips: "63461" },
    { name: "Payson", zips: "62360" },
    { name: "Liberty", zips: "62347" },
    { name: "Camp Point", zips: "62320" },
    { name: "Mendon", zips: "62351" },
    { name: "Ursa", zips: "62376" },
    { name: "Loraine", zips: "62349" },
    { name: "Golden", zips: "62339" },
    { name: "Clayton", zips: "62324" },
    { name: "La Grange, MO", zips: "63448" },
    { name: "Canton, MO", zips: "63435" },
    { name: "Monroe City, MO", zips: "63456" },
    { name: "Barry", zips: "62312" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 4.5 hours away but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Adams County and Tri-State travelers" },
    { icon: "ri-graduation-cap-line", title: "Quincy University Hub", desc: "Serving Quincy University students and faculty with study abroad and international academic travel" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from UPS Store on Broadway or any FedEx in Quincy — no 9-hour Chicago round trip" },
  ],
  internalLinks: [
    { name: "Expedited passport in Springfield, IL", route: "/springfield-il" },
    { name: "Emergency passport help in Hannibal, MO area", route: "/cities/quincy-il" },
    { name: "Urgent passport services in Quincy, FL", route: "/quincy" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Quincy, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (4.5 hours northeast via I-72 and I-55) — without you making the trip. Quincy residents can ship from UPS Store on Broadway or any FedEx location in Adams County. For Tri-State residents (IL/MO/IA), our courier service saves an entire day of driving — the Chicago round trip from Quincy is over 9 hours.",
  fpcOfficeDistance: "Serving Quincy, Hannibal MO, Palmyra MO, Payson, Liberty, Camp Point, Mendon, Ursa, Loraine, Golden, Clayton, La Grange MO, Canton MO, Monroe City MO, Barry, and all of Adams County and the Tri-State IL/MO region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Quincy and the entire Tri-State region. From the historic downtown Maine Street and Mississippi River bluffs to the Quincy University campus, from the residential neighborhoods to the surrounding Adams County communities — we serve Illinois' westernmost city and its Missouri neighbors.",
  nearbyCitiesIntro: "We serve Quincy and all nearby communities including Hannibal MO, Palmyra MO, Payson, Liberty, Camp Point, Mendon, Ursa, Loraine, Golden, Clayton, La Grange MO, Canton MO, Monroe City MO, and Barry.",
  howItWorksIntro: "Most Quincy travelers complete everything online and ship documents overnight. No need to drive 4.5 hours to Chicago — a 9-hour round trip that's completely impractical for western Illinois residents. Our couriers handle the Chicago Passport Agency trip for you.",
  mistakesIntro: "Quincy is Illinois' westernmost city on the Mississippi River, over 4 hours from the nearest passport agency in Chicago. Between Quincy University students heading abroad, Tri-State business travelers, and Mississippi River town families, here are the most common passport mistakes in the Gem City.",
  testimonialsIntro: "Quincy travelers — from Quincy University Hawks studying abroad and Tri-State business professionals to Mississippi River town families and Mark Twain history buffs — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Quincy, IL? Here are the most common ones we hear from Tri-State residents and Quincy University students.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "9+ hour round trip drive to Chicago", "Impractical for all Tri-State residents"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 9-hour round trip to Chicago required", "Perfect for Quincy University study abroad deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Quincy travelers with immediate departure needs — as fast as 24 hours. Essential for Quincy University study abroad deadlines and Tri-State last-minute international travel.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No 9-hour Chicago round trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Quincy adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Quincy address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Quincy residents — Quincy University students, new citizens, and Tri-State families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Quincy residents who lost their passport before study abroad, international business, or family travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Quincy, Hannibal, and Tri-State families traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Quincy and Adams County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Quincy residents who need land/sea travel to Canada or Mexico — perfect for Tri-State border region travelers.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Quincy residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Quincy business travelers and Tri-State professionals who frequently travel internationally and need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Quincy IL", description: "Urgent passport processing for Quincy Illinois travelers and Quincy University students with immediate departure needs." },
    { name: "Expedited Passport Renewal Quincy IL", description: "Fast passport renewal for Quincy Illinois residents and Tri-State travelers." },
    { name: "First-Time Passport Quincy IL", description: "New passport application services for Quincy Illinois residents." },
    { name: "Child Passport Quincy IL", description: "Minor passport services for Quincy Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sofia M.",
      location: "Quincy, IL — Quincy University",
      rating: 5,
      text: "Quincy University's semester in Rome — got accepted with 12 days to go and my passport was expired. Fast Passport Center renewed it in 4 days. I shipped from the UPS on Broadway — no way I was driving 9 hours to Chicago during finals. Now I'm in Italy. QU Hawks, this service is a must-know.",
      service: "Passport Renewal",
    },
    {
      name: "Bill H.",
      location: "Quincy, IL — Manufacturing Sales",
      rating: 5,
      text: "International trade show in Dusseldorf — got the green light with 6 days notice. My passport was water-damaged from a Mississippi River fishing trip. Fast Passport Center processed a damaged replacement in 3 days. The 9-hour Chicago drive is completely unrealistic from Quincy. This courier service is the only way.",
      service: "Damaged Passport",
    },
    {
      name: "The Kowalski Family",
      location: "Quincy, IL",
      rating: 5,
      text: "Family heritage trip to Poland — booked the flights then realized none of us had valid passports. Fast Passport Center handled all 4 of us — including 2 first-time child passports — in 5 days. The Adams County Circuit Clerk downtown was great. Tri-State families, skip the Chicago trip — use this service.",
      service: "Family Passport Package",
    },
  ],
  facilities: [
    {
      id: "qcy-1",
      name: "Quincy Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3535 Locust St",
      city: "Quincy",
      state: "IL",
      zip: "62301",
      phone: "(217) 222-0444",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Quincy, on Locust Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Quincy acceptance facility. Located on Locust Street with convenient access from downtown and Broadway. Appointments recommended. Near the Quincy Mall area.",
      icon: "ri-mail-line",
    },
    {
      id: "qcy-2",
      name: "Adams County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "521 Vermont St",
      city: "Quincy",
      state: "IL",
      zip: "62301",
      phone: "(217) 277-2100",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Quincy, Adams County Courthouse, downtown",
      website: "https://www.adamscountyil.gov/",
      websiteLabel: "Adams County Circuit Clerk",
      notes: "Adams County acceptance facility at the county courthouse on Vermont Street in downtown Quincy. Historic courthouse setting near Maine Street and the Mississippi River bluffs. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "qcy-3",
      name: "Hannibal Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "801 Broadway",
      city: "Hannibal",
      state: "MO",
      zip: "63401",
      phone: "(573) 221-2755",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hannibal, MO, approximately 20 miles south of Quincy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hannibal, Missouri — Mark Twain's boyhood home. Convenient for Tri-State residents in the Hannibal area. Good alternative when Quincy post office is busy. About 20 minutes from Quincy via I-172/US-61.",
      icon: "ri-mail-line",
    },
    {
      id: "qcy-4",
      name: "Palmyra Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "104 E Olive St",
      city: "Palmyra",
      state: "MO",
      zip: "63461",
      phone: "(573) 769-2711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Palmyra, MO, approximately 15 miles northwest of Quincy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Palmyra, Missouri. Convenient for northern Tri-State residents near the Marion County line. Smaller facility with generally shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "qcy-5",
      name: "Pittsfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "119 N Monroe St",
      city: "Pittsfield",
      state: "IL",
      zip: "62363",
      phone: "(217) 285-4113",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Pittsfield, approximately 40 miles southeast of Quincy",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Pittsfield and Pike County. Convenient for eastern Adams County and Pike County residents. Good alternative for southeastern Tri-State travelers.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Chicago", fpc: "No — ship from Quincy" },
    { feature: "Time Commitment", agency: "9+ hour round trip — entire day lost", fpc: "Minutes — ship from Broadway Street" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for Tri-State", agency: "No — an entire workday for driving", fpc: "Yes — the only practical option" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Quincy University Deadlines",
      description: "Quincy University students often discover passport issues just weeks before study abroad programs begin. With Chicago 4.5 hours away (9 hours round trip), students in western Illinois have essentially zero practical in-person emergency options. Our courier service is the only viable fast solution for QU Hawks.",
    },
    {
      icon: "ri-road-map-line",
      title: "The 9-Hour Chicago Nightmare",
      description: "Quincy to Chicago is 4.5 hours each way — a 9+ hour round trip. That's an entire workday spent driving. With gas, tolls, meals, parking, and possibly a hotel if you can't finish in one day, attempting to 'just drive to Chicago' is one of the biggest passport mistakes a Tri-State resident can make.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule",
      description: "Many Quincy University students and Tri-State travelers don't realize that European and Asian countries require 6 months of passport validity past the return date. A passport valid for 3 more months won't get you on a plane to Italy, Germany, or Japan — all popular QU study abroad destinations.",
    },
    {
      icon: "ri-image-line",
      title: "Non-Compliant Passport Photos",
      description: "Quincy residents sometimes try DIY passport photos or use non-certified retailers. These almost always fail Department of State standards. Use UPS Store on Broadway or Walgreens for compliant photos. A photo rejection means starting over — and when you're in Quincy, every day counts.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Form for First-Timers",
      description: "Using DS-82 instead of DS-11 is the top rejection reason at Quincy and Hannibal acceptance facilities. QU freshmen getting their first passport are especially vulnerable to this error. Our document review ensures the correct form before submission — preventing a 2+ week delay.",
    },
    {
      icon: "ri-global-line",
      title: "Tri-State Airport Confusion",
      description: "Tri-State travelers often don't plan for the fact that their nearest international airport (STL) is 2 hours south, and O'Hare is 4.5 hours northeast. Don't book international flights before confirming your passport is valid for at least 6 months past return — you may waste non-refundable tickets.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from Quincy University campus, your home, or anywhere in the Tri-State area." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at UPS Store on Broadway or any FedEx in Quincy." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with QU study abroad, Tri-State business travel, and Adams County family needs." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 4.5 hours away but you never make the drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Quincy address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Quincy, IL?", a: "Fast Passport Center offers emergency passport processing in Quincy, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (4.5 hours northeast via I-72 and I-55) — without you making the trip. For western Illinois and Tri-State residents, this saves a 9+ hour round trip drive." },
    { q: "Does Quincy have a passport agency?", a: "No — Quincy does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 4.5 hours northeast. Fast Passport Center's courier service is the only practical fast option for the Tri-State region — the Chicago drive is completely unrealistic for most residents." },
    { q: "Do you serve Quincy University students?", a: "Absolutely. Fast Passport Center serves Quincy University students, faculty, and staff. We understand study abroad programs, international service trips, and academic travel. Our 24–48 hour service is ideal for QU Hawks who applied late or received last-minute acceptance to international programs." },
    { q: "What airport do Quincy travelers use for international flights?", a: "Quincy has the Quincy Regional Airport (UIN) for regional flights to St. Louis and Chicago. For international flights, most Tri-State travelers use St. Louis Lambert International Airport (STL) — approximately 2 hours south via I-172/US-61. Chicago O'Hare (ORD) is approximately 4.5 hours northeast." },
    { q: "Can I just drive to St. Louis for passport help?", a: "St. Louis does have passport acceptance facilities but no regional passport agency with same-day service. The nearest agency with emergency processing is still Chicago — 4.5 hours away. Fast Passport Center's courier service is the only practical 24–48 hour option for Quincy residents." },
    { q: "Can I get my child's passport expedited in Quincy?", a: "Yes. Fast Passport Center expedites child passports in Quincy for minors under 16. Both parents must appear or submit notarized consent. We guide Adams County and Tri-State families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Quincy?", a: "The UPS Store on Broadway, Walgreens on Broadway, and CVS all offer passport photos. The Quincy Post Office on Locust Street may also provide photo services. Photos must be 2x2 inches on a white background — no exceptions." },
    { q: "Is there really no other fast option from Quincy?", a: "Honestly — no. The Chicago Passport Agency is 4.5 hours away (9 hours round trip) and requires appointments booked weeks in advance. For urgent international travel from western Illinois, Fast Passport Center's courier service is the only practical 24–48 hour option. It's why QU students, Tri-State professionals, and Quincy families depend on us." },
  ],
  photoLocations: [
    { name: "UPS Store — Quincy", address: "4821 Broadway St, Quincy, IL 62305", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM" },
    { name: "Walgreens — Quincy", address: "3700 Broadway St, Quincy, IL 62305", hours: "Mon–Sun: 8AM–10PM" },
    { name: "CVS — Quincy", address: "1500 N 18th St, Quincy, IL 62301", hours: "Mon–Sun: 8AM–9PM" },
    { name: "Quincy Post Office", address: "3535 Locust St, Quincy, IL 62301", hours: "Mon–Fri: 9AM–4:30PM (photo services by appointment)" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Quincy", address: "3701 E Lake Centre Dr, Quincy, IL 62305", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Located near the Quincy Mall area off Broadway. Online reservations strongly recommended.", featured: true },
    { name: "Missouri DMV — Hannibal", address: "315 Clinic Rd, Hannibal, MO 63401", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Missouri DMV serving Hannibal area residents. REAL ID processing available. About 20 minutes from Quincy — convenient for Tri-State Missouri residents.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for Adams County birth and death certificates" },
    { label: "Marriage Licenses (Adams County Clerk)", url: "https://www.adamscountyil.gov/county-clerk", desc: "Adams County Clerk — marriage license applications and certified copies for Quincy and surrounding areas" },
    { label: "Divorce Decrees (Adams County Circuit Clerk)", url: "https://www.adamscountyil.gov/circuit-clerk", desc: "Adams County Circuit Clerk — divorce decree records for Quincy and Adams County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "UIN",
      name: "Quincy Regional Airport — Baldwin Field",
      distance: "Approximately 10 minutes east of downtown Quincy",
      address: "1647 IL-104, Quincy, IL 62305",
      note: "Regional airport with daily flights to St. Louis Lambert (STL) and Chicago O'Hare (ORD) via Southern Airways Express. Convenient for connecting to international flights without the 2+ hour drive.",
      flightUrl: "https://www.quincyil.gov/",
      flightLabel: "UIN Flight Info",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "Approximately 2 hours south via I-172/US-61/I-70",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major airport with domestic and international flights. The closest major airport to Quincy — about 2 hours south. Good for Southwest Airlines, American, Delta, and United connections.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Flight Info",
      featured: false,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 4 hours 30 minutes northeast via I-72/I-55",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with the most extensive global connections. The long drive makes this impractical for most Quincy travelers except those needing specific international routes. Regional flights from UIN connect to ORD.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
};